import SarasErpApi from '../../../helper/SarasErpApi';

const ioRequest = async function (action, actionObj, onSuccessCallBack) {
    let params = { actionName: action, ...actionObj }
    let requestObject = {
        actionName: action,
        actionId: actionObj.actionId || 'show',
        viewData: {
        },
        dataList: {
            ...params
        }
    }
    // console.log('IORequest1', requestObject)
    const response = await SarasErpApi.post('core', requestObject);
    //console.log('IORequest',requestObject)
    if (onSuccessCallBack) onSuccessCallBack(actionObj, response);
}

var uploadTemplateFile = function (docTypeId, files, onSuccess) {

    var doctyid = docTypeId;
    //let files = e.currentTarget.files;
    if (files.length === 0) {
        return;
    }
    var formdata = new FormData();
    for (var i = 0; i < files.length; i++) {
        formdata.append(files[i].name, files[i]);
    }

    formdata.set("actionName", "mediaManage");
    formdata.set("actionId", "upload");
    formdata.set("dtId", doctyid);
    formdata.set("dId", 0);
    formdata.set("rtId", 0);
    formdata.set("rId", 0);
    formdata.set("rt", "a");

    SarasErpApi.post('rs', formdata).then((response) => {
        //console.log(response, response.data.dataList);
        if (onSuccess) onSuccess(response.data.dataList);
    });
}

export { ioRequest, uploadTemplateFile };